// extracted by mini-css-extract-plugin
export default {"container":"Halls_container__wXT2b","title":"Halls_title__sdNnv"};